interface TimelineFilterOptions {
  id: string;
  value: any;
}

export interface TimelineActivityFilters {
  type: string;
  id: string;
  description: string;
  items?: TimelineFilterOptions[];
  icons?: string;
}

export interface TimelineFilter {
  activityTypes: TimelineFilterOptions[];
  tags: TimelineFilterOptions[];
  categories: TimelineFilterOptions[];
  severities: TimelineFilterOptions[];
  statuses: TimelineFilterOptions[];
  assignedTo: TimelineFilterOptions[];
}

export interface TimelineFilterLabels {
  categories: string;
  severities: string;
  statuses: string;
  tags: string;
}

export const getTimelineFilters = (
  { activityTypes, tags, categories, severities, statuses, assignedTo }: TimelineFilter,
  labels: TimelineFilterLabels
): TimelineActivityFilters[] => {
  return [
    {
      type: 'select',
      id: 'type',
      description: 'Activity Type',
      items: activityTypes,
    },
    {
      type: 'date',
      id: 'dateRange',
      description: 'Date',
    },
    {
      type: 'select',
      id: 'category',
      description: labels.categories,
      items: categories,
    },
    {
      type: 'select',
      id: 'severity',
      description: labels.severities,
      items: severities,
    },
    {
      type: 'select',
      id: 'status',
      description: labels.statuses,
      items: statuses,
    },
    {
      type: 'multiselect',
      id: 'assignedTo',
      description: 'Assigned To',
      items: assignedTo,
    },
    {
      type: 'multiselect',
      id: 'tags',
      description: labels.tags,
      items: tags,
    },
  ];
};
